exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__inactive___1j-BT{color:#000!important;background:none!important;border:1px solid #e2e2e2}.style__tagButton___10Q22{padding:.35rem;margin-bottom:.25rem}.style__tagInner___2DmOq{margin-left:1rem!important}", "", {"version":3,"sources":["/./components/tagList/style.css"],"names":[],"mappings":"AAAA,yBACC,qBAAwB,AACxB,0BAA4B,AAC5B,wBAA0B,CAC1B,AAED,0BACC,eAAiB,AACjB,oBAAuB,CACvB,AAED,yBACC,0BAA6B,CAC7B","file":"style.css","sourcesContent":[".inactive {\n\tcolor: black !important;\n\tbackground: none !important;\n\tborder: 1px solid #e2e2e2;\n}\n\n.tagButton {\n\tpadding: 0.35rem;\n\tmargin-bottom: 0.25rem;\n}\n\n.tagInner {\n\tmargin-left: 1rem !important;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"inactive": "style__inactive___1j-BT",
	"tagButton": "style__tagButton___10Q22",
	"tagInner": "style__tagInner___2DmOq"
};


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!/data/www/SGDBackend-Nex2/~/postcss-loader!./components/tagList/style.css
// module id = 552
// module chunks = 0